import { useMutation } from '@tanstack/react-query';
import { withdrawalReportService } from 'commons/services/withdrawalReportService';

interface UseCreateWithdrawalPdfReportMutationProps {
  onSuccess: (requestId: number) => void;
  onError?: () => void;
}

export function useCreateWithdrawalPdfReportMutation({
  onSuccess,
  onError,
}: UseCreateWithdrawalPdfReportMutationProps) {
  return useMutation(
    (withdrawalId: number) =>
      withdrawalReportService.createWithdrawalPdfReport(withdrawalId),
    {
      onSuccess: (data) => {
        onSuccess(data.requestId);
      },
      onError: () => {
        onError?.();
      },
    },
  );
}
